/* eslint-disable consistent-return */
import { RouterV2Enum } from '@/router/router-names';
import { Component, Vue } from 'vue-property-decorator';
import { cache } from '@/shared/utils/Cache';
import { ubtPage } from '@/shared/utils/ubt';
import platform from '@/shared/utils/platform';
import { goBack } from '@/api/native/utils';

@Component
export default class RedirectHomeH5 extends Vue {
  // 跳转的目标链接
  private nextUrl: string = RouterV2Enum.home;

  // 记录当前链接是否进入过页面
  private isEenteredKey = `isEnteredKey_${this.nextUrl}`;

  // 进入页面的时间存储key
  private appStartupTimeKey = 'APP_STARTUP_TIME';

  private created() {
    const now = new Date().getTime();
    const isEntered = cache.get(this.isEenteredKey);

    // 全应用进出的埋点
    if (!isEntered) {
      cache.set(this.isEenteredKey, true);
      cache.set(this.appStartupTimeKey, now);

      ubtPage('APP_H5', '', now);
    } else {
      cache.remove(this.isEenteredKey);
      ubtPage('APP_H5', '', cache.get(this.appStartupTimeKey), now);

      return goBack();
    }

    this.$router.push({
      path: platform.isAliMP ? '/alimini-home' : this.nextUrl,
      query: this.$route.query,
      params: this.$route.params,
    });
  }

  private render() {
    return '';
  }
}
